"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const r=require("./index61.js");var e=r.functionUncurryThis,i=e([].slice);exports.arraySlice=i;
